const ConsentformEn = {
  pageTitle: "Children Burns Study",
  language: "English",
  organization: "BGU",
  formTitle: "Consent form",

  parentSection: {
    greeting: "Dear Parent,",
    paragraphs: [
      "The purpose of the current study is to deepen our understanding of burns in children ranging from three months to 18 years of age.",
      "Your participation is highly valued and crucial to our research.",
      "This study is a collaborative effort between Ben Gurion University of the Negev and Haddasa Medical Center.\n Participation involves answering just seven questions, and providing a photo of the burn is entirely voluntary and takes approximately five minutes.",
      "You may choose to skip any question at your discretion.",
      "We do not request any personal information such as your name or address.",
      "Furthermore, in any scientific publications related to this research, neither you nor your child will be identified.",
      "Your involvement in this study poses no risk and does not offer any direct benefit.",
      "Should you have any questions or concerns regarding this study, please do not hesitate to contact us using the details below.",
      "We hope for a speedy recovery for your child and sincerely appreciate the time you dedicate to this research endeavour."
    ],
    closing: "Thank you.",
    team: "The research team",
    contactText: "For contact please write to-",
    email: "taliamst@bgu.ac.il",
    phoneText: "or by phone",
    phone: "0545655164"
  },

  doctorSection: {
    title: "Doctor",
    declaration: [
      "With my signature, I declare that I explained the research to the minor's parent as written in this form. \n I believe that the parent understood what was said, he had enough time to read the form and the parent expressed his consent to participate in the study.",
      "In addition, I declare that I explained the research to the minor in the presence of his parents and he expressed his desire to participate in the research."
    ],
    doctorNameLabel: "Doctor`s name",
    doctorName: "Dr. Israeli Israeli",
    HospitalName: "Hospital name",
    clickToSign: "Click to sign",
    signature: "Signature",
    licenseNumberLabel: "License number",
    licenseNumber: "1685723",
    dateLabel: "Date",
    date: "02/03/2024"
  },

  parentApprovalSection: {
    fullNameLabel: "Full name",
    parentNameLabel: "Parent Name",
    serialNumberLabel: "Serial number",
    serialNumber: "12-986-45",
    approvalLabel: "Approval"
  },
  signature: {
  clickToSign: "Click here to sign",
  title: "Signature",
  instruction: "Please sign inside the marked box",
  save: "Save",
  clear: "Clear Signature",
  previewAlt: "Signature preview"
},
  error: {
    required:"*This field is required",
    require2:"*Please enter first and last name",
    doctorName: "Please enter the doctor`s name",
    licenseNumber: "Please enter the license number",
    HospitalName: "Please enter the hospital name"
  }
};

export default ConsentformEn;
